module.exports = __webpack_public_path__ + "img/nodata.7f0fec50.png";